export default __webpack_public_path__ + "static/media/cowboy-register.3132c660.png";